var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFunnel2Icon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99999 13.2533C10.0267 13.4533 9.95999 13.6667 9.80665 13.8067C9.54665 14.0667 9.12665 14.0667 8.86665 13.8067L6.19332 11.1333C6.03999 10.98 5.97332 10.7733 5.99999 10.58V7.16667L2.80665 3.08C2.57999 2.79333 2.63332 2.37333 2.91999 2.14667C3.04665 2.05333 3.18665 2 3.33332 2H12.6667C12.8133 2 12.9533 2.05333 13.08 2.14667C13.3667 2.37333 13.42 2.79333 13.1933 3.08L9.99999 7.16667V13.2533ZM4.69332 3.33333L7.33332 6.70667V10.3867L8.66665 11.72V6.7L11.3067 3.33333H4.69332Z",
    fill: "#808080"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFunnel2Icon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/funnel2-icon.ecea0e8e3f4af740b52e5128d5d244cd.svg";